import { createFileRoute } from "@tanstack/react-router";

import UserSettings from "@/components/organisms/user/UserSettings";

const Settings = () => {
  return (
    <div className="p-6">
      <div className="max-w-2xl">
        <h1 className="mb-6 text-2xl font-semibold text-gray-900">Settings</h1>

        <UserSettings />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/settings")({
  component: Settings,
});
